module.exports = __webpack_public_path__ + "img/OKEO.79d65ac3.jpg";